import { useContext, useEffect, useState } from 'react';
import Button from '../../../../components/Button/Button';
import Modal from '../../../../components/Modal/Modal';
import api from '../../../../js/api';
import './Bingo.scss';
import { UserContext } from '../../../../js/UserContext';
import { useParams, useSearchParams } from 'react-router-dom';
import { base64ToBlob, compressImage, request_image } from '../../../../js/utils';
import useDialog from '../../../../hooks/useDialog';

export default function Challenge({ data, className, onToggle }) {

    const { user } = useContext(UserContext);
    const { roomNumber } = useParams();
    const [s_params] = useSearchParams();
    const login_spy = s_params.get('login');

    const [completed, setCompleted] = useState(data.completed || false);
    const [imageUrl, setImageUrl] = useState(null);
    const [showImageInModal, setShowImageInModal] = useState(false);
    const { confirm, alert, DialogUI } = useDialog();

    const fetchThumbnail = async () => {
        const l = login_spy || user?.login;
        if (!l) return;
        const response = await api.get(
            `/users/${l}/rooms/${roomNumber}/challenges/${data.challenge.id}/image`,
            { silent: true }
        );
        if (!response || !response.image || response.error) return;
        const blob = base64ToBlob(response.image, 'image/jpeg');
        setImageUrl(URL.createObjectURL(blob));
    };

    useEffect(() => {
        if (data.completed && data.challenge.image_required) {
            fetchThumbnail();
        }
    }, []);

    if (!data || !data.challenge) {
        console.error('Invalid challenge data:', data);
        return <p>Error: Invalid challenge data.</p>;
    }

    const buttons = {
        complete:
            <Button text="Complete" onClick={async () => {
                const ok = await confirm(`¿Marcar "${data.challenge.title}" como completado?`);
                if (!ok) return;

                if (!data.challenge.image_required) {
                    const response = await api.put(`/users/${user.login}/rooms/${roomNumber}/challenges/${data.challenge.id}`, {
                        completed: true,
                    });
                    if (response && response.error) { await alert(response.error); return; }
                    setCompleted(true);
                    onToggle?.(1);
                    return;
                }
                request_image(async (image) => {
                    if (!image) return;
                    const img_small = await compressImage(image, 1024, 0.8);
                    const r = await api.postFormData(`/users/${user.login}/rooms/${roomNumber}/challenges/${data.challenge.id}/image`, {
                        image: img_small,
                    });
                    if (r.status === 413) { await alert('La imagen es demasiado grande.'); return; }
                    if (r.status !== 200) { await alert(`Error ${r.status}: ${r.statusText}`); return; }
                    if (r?.error) { await alert(r.error); return; }
                    setCompleted(true);
                    onToggle?.(1);
                    fetchThumbnail();
                });
            }} />,
        incomplete:
            <Button text="Incomplete" onClick={async () => {
                const ok = await confirm(`¿Marcar "${data.challenge.title}" como incompleto?`);
                if (!ok) return;
                const response = await api.put(`/users/${user.login}/rooms/${roomNumber}/challenges/${data.challenge.id}`, {
                    completed: false
                });
                if (response && response.error) { await alert(response.error); return; }
                setCompleted(false);
                setImageUrl(null);
                setShowImageInModal(false);
                onToggle?.(-1);
            }} />,
        view_image:
            <Button text={showImageInModal ? 'Ocultar imagen' : 'Ver imagen'} onClick={async () => {
                if (showImageInModal) { setShowImageInModal(false); return; }
                if (!imageUrl) await fetchThumbnail();
                setShowImageInModal(true);
            }} />,
        download_image:
            <Button text="Descargar" onClick={async () => {
                let src = imageUrl;
                if (!src) {
                    const l = login_spy || user?.login;
                    const response = await api.get(
                        `/users/${l}/rooms/${roomNumber}/challenges/${data.challenge.id}/image`,
                        { silent: true }
                    );
                    if (!response || !response.image || response.error) {
                        await alert('No hay imagen para este reto.');
                        return;
                    }
                    const blob = base64ToBlob(response.image, 'image/jpeg');
                    src = URL.createObjectURL(blob);
                    setImageUrl(src);
                }
                const a = document.createElement('a');
                a.href = src;
                a.download = `bingo-${data.challenge.id}.jpg`;
                a.click();
            }} />,
    };

    const cellStyle = imageUrl
        ? { backgroundImage: `url(${imageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : {};

    return (
        <div
            className={`bingo-challenge ${className} ${completed ? 'challenge-completed' : ''} ${imageUrl ? 'has-thumbnail' : ''}`}
            style={cellStyle}
        >
            {DialogUI}
            <Modal text={data.challenge.title}>
                <div className='bingo-challenge-content'>
                    <h2>{data.challenge.title}</h2>
                    <br />
                    <p>{data.challenge.description}</p>
                    <br />
                    <hr />
                    <div className='flex flex-row flex-center gap'>
                        {!login_spy
                            ? (completed ? buttons.incomplete : buttons.complete)
                            : null
                        }
                        {completed && data.challenge.image_required ? buttons.view_image : null}
                        {completed && data.challenge.image_required ? buttons.download_image : null}
                    </div>
                    {showImageInModal && imageUrl && (
                        <img
                            src={imageUrl}
                            alt={data.challenge.title}
                            style={{ width: '100%', marginTop: '1rem', borderRadius: '8px' }}
                        />
                    )}
                </div>
            </Modal>
        </div>
    );
}